import { Directive, HostListener } from '@angular/core'

@Directive({
  selector: '[appStopClickPropagation]',
  standalone: true,
})
// Taken from https://github.com/primefaces/primeng/issues/7441#issuecomment-508677945
export class StopClickPropagationDirective {
  @HostListener('click', ['$event'])
  public onClick (event: any): void {
    event.stopPropagation()
  }
}
